import { render } from "./NavItem.vue?vue&type=template&id=c65c77b2&scoped=true&ts=true"
import script from "./NavItem.vue?vue&type=script&lang=ts"
export * from "./NavItem.vue?vue&type=script&lang=ts"

import "./NavItem.vue?vue&type=style&index=0&id=c65c77b2&lang=less&scoped=true"

import exportComponent from "D:\\phpStudy_pro\\WWW\\drchat-v2\\front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c65c77b2"]])

export default __exports__